/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import ErrorHandlerHelpers from '../../mixins/ErrorHandlerHelpers';
import DataSyncService from '../../services/DataSyncService';
import Idb from '../../services/IndexedDbService';

const SET_DATA_SYNCING_BOOL = 'SET_DATA_SYNCING_BOOL';

const ADD_VOYAGE_REPORT_TO_BE_SYNCED = 'ADD_VOYAGE_REPORT_TO_BE_SYNCED';
const SET_VOYAGE_REPORTS_TO_BE_SYNCED = 'SET_VOYAGE_REPORTS_TO_BE_SYNCED';
const CLEAR_VOYAGE_REPORTS_TO_BE_SYNCED = 'CLEAR_VOYAGE_REPORTS_TO_BE_SYNCED';

const ADD_VESSEL_ACTIVITY_TO_BE_SYNCED = 'ADD_VESSEL_ACTIVITY_TO_BE_SYNCED';
const SET_VESSEL_ACTIVITIES_TO_BE_SYNCED = 'SET_VESSEL_ACTIVITIES_TO_BE_SYNCED';
const CLEAR_VESSEL_ACTIVITIES_TO_BE_SYNCED = 'CLEAR_VESSEL_ACTIVITIES_TO_BE_SYNCED';

const SET_ALL_VESSEL_ACTIVITIES_TO_BE_SYNCED = 'SET_ALL_VESSEL_ACTIVITIES_TO_BE_SYNCED';
const CLEAR_ALL_VESSEL_ACTIVITIES_TO_BE_SYNCED = 'CLEAR_VESSEL_ACTIVITIES_TO_BE_SYNCED';

const SET_BULK_TRANSACTIONS_TO_BE_SYNCED = 'SET_BULK_TRANSACTIONS_TO_BE_SYNCED';
const CLEAR_BULK_TRANSACTIONS_TO_BE_SYNCED = 'CLEAR_BULK_TRANSACTIONS_TO_BE_SYNCED';

const SET_ALL_BULK_TRANSACTIONS_TO_BE_SYNCED = 'SET_ALL_BULK_TRANSACTIONS_TO_BE_SYNCED';
const CLEAR_ALL_BULK_TRANSACTIONS_TO_BE_SYNCED = 'CLEAR_ALL_BULK_TRANSACTIONS_TO_BE_SYNCED';

const SET_TANKS_WITH_CURRENT_STATUS_TO_BE_SYNCED = 'SET_TANKS_WITH_CURRENT_STATUS_TO_BE_SYNCED';
const CLEAR_TANKS_WITH_CURRENT_STATUS_TO_BE_SYNCED = 'CLEAR_TANKS_WITH_CURRENT_STATUS_TO_BE_SYNCED';

const ADD_PASSENGER_TO_BE_SYNCED = 'ADD_PASSENGER_TO_BE_SYNCED';
const REMOVE_PASSENGER_TO_BE_SYNCED = 'REMOVE_PASSENGER_TO_BE_SYNCED';
const SET_PASSENGERS_TO_BE_SYNCED = 'SET_PASSENGERS_TO_BE_SYNCED';
const CLEAR_PASSENGERS_TO_BE_SYNCED = 'CLEAR_PASSENGERS_TO_BE_SYNCED';

const ADD_SAFETY_OBSERVATION_TO_BE_SYNCED = 'ADD_SAFETY_OBSERVATION_TO_BE_SYNCED';
const REMOVE_SAFETY_OBSERVATION_TO_BE_SYNCED = 'REMOVE_SAFETY_OBSERVATION_TO_BE_SYNCED';
const SET_SAFETY_OBSERVATIONS_TO_BE_SYNCED = 'SET_SAFETY_OBSERVATIONS_TO_BE_SYNCED';
const CLEAR_SAFETY_OBSERVATIONS_TO_BE_SYNCED = 'CLEAR_SAFETY_OBSERVATIONS_TO_BE_SYNCED';

const SET_ALL_CARGO_LINES_TO_BE_SYNCED = 'SET_CARGO_LINES_TO_BE_SYNCED';
const CLEAR_ALL_CARGO_LINES_TO_BE_SYNCED = 'CLEAR_CARGO_LINES_TO_BE_SYNCED';
const SET_CARGO_LINES_TO_BE_SYNCED = 'SET_CARGO_LINES_TO_BE_SYNCED';
const CLEAR_CARGO_LINES_TO_BE_SYNCED = 'CLEAR_CARGO_LINES_TO_BE_SYNCED';

const state = {
  voyageReportsToBeSynced: [],

  vesselActivitiesToBeSynced: [],
  allVesselActivitiesToBeSynced: [],

  bulkTransactionsToBeSynced: [],
  allBulkTransactionsToBeSynced: [],

  tanksWithCurrentStatusToBeSynced: [],

  passengersToBeSynced: [],

  safetyObservationsToBeSynced: [],

  cargoLinesToBeSynced: [],
  allCargoLinesToBeSynced: [],

  dataSyncing: false,
};

const getters = {
  getAllUnSyncedVesselActivities:
    (state) => [].concat(state.allVesselActivitiesToBeSynced),
  getUnsyncedBulkTransactionsForActivity:
    (state) => [].concat(state.bulkTransactionsToBeSynced),
  getAllUnsyncedBulkTransactions:
    (state) => [].concat(state.allBulkTransactionsToBeSynced),
  getUnsyncedTankStatuses:
    (state) => [].concat(state.tanksWithCurrentStatusToBeSynced),
  getLatestUnsyncedTankStatuses:
    (state) => [].concat(state.tanksWithCurrentStatusToBeSynced
      .filter((x) => x.currentTankStatus.isLatest)),
  getUnsyncedCargoLinesForVoyage:
    (state) => [].concat(state.cargoLinesToBeSynced),
  getAllUnsyncedPassengers: (state) => [].concat(state.passengersToBeSynced),
  getAllUnsyncedSafetyObservations: (state) => [].concat(state.safetyObservationsToBeSynced)
};

const mutations = {
  [SET_DATA_SYNCING_BOOL](state, isSyncing) {
    state.dataSyncing = isSyncing;
  },
  [ADD_VOYAGE_REPORT_TO_BE_SYNCED](state, voyageReport) {
    state.voyageReportsToBeSynced = (state.voyageReportsToBeSynced || []).concat([voyageReport]);
  },
  [SET_VOYAGE_REPORTS_TO_BE_SYNCED](state, voyageReports) {
    state.voyageReportsToBeSynced = [].concat(voyageReports);
  },
  [CLEAR_VOYAGE_REPORTS_TO_BE_SYNCED](state) {
    state.voyageReportsToBeSynced = [];
  },
  [ADD_VESSEL_ACTIVITY_TO_BE_SYNCED](state, vesselActivity) {
    state.vesselActivitiesToBeSynced = (state.vesselActivitiesToBeSynced || [])
      .concat([vesselActivity]);
  },
  [SET_VESSEL_ACTIVITIES_TO_BE_SYNCED](state, vesselActivities) {
    state.vesselActivitiesToBeSynced = [].concat(vesselActivities);
  },
  [CLEAR_VESSEL_ACTIVITIES_TO_BE_SYNCED](state) {
    state.vesselActivitiesToBeSynced = [];
  },
  [SET_ALL_VESSEL_ACTIVITIES_TO_BE_SYNCED](state, vesselActivities) {
    state.allVesselActivitiesToBeSynced = [].concat(vesselActivities);
  },
  [CLEAR_ALL_VESSEL_ACTIVITIES_TO_BE_SYNCED](state) {
    state.allVesselActivitiesToBeSynced = [];
  },
  [SET_BULK_TRANSACTIONS_TO_BE_SYNCED](state, bulkTransactions) {
    state.bulkTransactionsToBeSynced = [].concat(bulkTransactions);
  },
  [CLEAR_BULK_TRANSACTIONS_TO_BE_SYNCED](state) {
    state.bulkTransactionsToBeSynced = [];
  },
  [SET_ALL_BULK_TRANSACTIONS_TO_BE_SYNCED](state, bulkTransactions) {
    state.allBulkTransactionsToBeSynced = [].concat(bulkTransactions);
  },
  [CLEAR_ALL_BULK_TRANSACTIONS_TO_BE_SYNCED](state) {
    state.allBulkTransactionsToBeSynced = [];
  },
  [SET_TANKS_WITH_CURRENT_STATUS_TO_BE_SYNCED](state, tankStatuses) {
    state.tanksWithCurrentStatusToBeSynced = [].concat(tankStatuses);
  },
  [CLEAR_TANKS_WITH_CURRENT_STATUS_TO_BE_SYNCED](state) {
    state.tanksWithCurrentStatusToBeSynced = [];
  },
  [ADD_PASSENGER_TO_BE_SYNCED](state, passenger) {
    state.passengersToBeSynced = (state.passengersToBeSynced || []).concat([passenger]);
  },
  [REMOVE_PASSENGER_TO_BE_SYNCED](state, passenger) {
    state.passengersToBeSynced = state.passengersToBeSynced.filter((x) => x.idc === passenger.idc);
  },
  [SET_PASSENGERS_TO_BE_SYNCED](state, passengers) {
    state.passengersToBeSynced = [].concat(passengers);
  },
  [CLEAR_PASSENGERS_TO_BE_SYNCED](state) {
    state.passengersToBeSynced = [];
  },
  [ADD_SAFETY_OBSERVATION_TO_BE_SYNCED](state, safetyObservation) {
    state.safetyObservationsToBeSynced = (state.safetyObservationsToBeSynced || []).concat([safetyObservation]);
  },
  [REMOVE_SAFETY_OBSERVATION_TO_BE_SYNCED](state, safetyObservation) {
    state.safetyObservationsToBeSynced = state.safetyObservationsToBeSynced.filter((x) => x.idc === safetyObservation.idc);
  },
  [SET_SAFETY_OBSERVATIONS_TO_BE_SYNCED](state, safetyObservations) {
    state.safetyObservationsToBeSynced = [].concat(safetyObservations);
  },
  [CLEAR_SAFETY_OBSERVATIONS_TO_BE_SYNCED](state) {
    state.safetyObservationsToBeSynced = [];
  },
  [SET_ALL_CARGO_LINES_TO_BE_SYNCED](state, cargoLines) {
    state.allCargoLinesToBeSynced = [].concat(cargoLines);
  },
  [CLEAR_ALL_CARGO_LINES_TO_BE_SYNCED](state) {
    state.allCargoLinesToBeSynced = [];
  },
  [SET_CARGO_LINES_TO_BE_SYNCED](state, cargoLines) {
    state.cargoLinesToBeSynced = [].concat(cargoLines);
  },
  [CLEAR_CARGO_LINES_TO_BE_SYNCED](state) {
    state.cargoLinesToBeSynced = [];
  },
};

function filterActivities(x, Id) {
  let matchId = false;
  let matchIdc = false;
  if (x.voyageReportIdc) {
    matchIdc = x.voyageReportIdc.toString() === Id.toString();
  }

  if (x.voyageReportId) {
    matchId = x.voyageReportId.toString() === Id.toString();
  }

  return matchId || matchIdc;
}

function matchIdOrIdc(x, voyageReportId) {
  let matchId = false;
  let matchIdc = false;
  if (x.idc) {
    matchIdc = x.idc.toString() === voyageReportId.toString();
  }

  if (x.id) {
    matchId = x.id.toString() === voyageReportId.toString();
  }

  return matchId || matchIdc;
}

const actions = ({
  loadVoyageReportsToBeSynced({ commit }) {
    return Idb.getVoyageReports()
      .then((voyageReports) => {
        commit(SET_VOYAGE_REPORTS_TO_BE_SYNCED, voyageReports);
      });
  },
  loadOfflineVoyageReportDetails({ commit }, voyageReportId) {
    const unsyncedReport = state.voyageReportsToBeSynced
      .find((x) => matchIdOrIdc(x, voyageReportId));

    if (unsyncedReport) {
      commit('voyageReportsStore/SET_VOYAGE_REPORT_DETAILS_DATA', unsyncedReport, { root: true });
    }
  },
  loadAllVesselActivitiesToBeSynced({ commit }) {
    return Idb.getVesselActivities()
      .then((vesselActivities) => {
        commit(SET_ALL_VESSEL_ACTIVITIES_TO_BE_SYNCED, vesselActivities);
      });
  },
  loadVesselActivitiesToBeSynced({ commit }, Id) {
    return Idb.getVesselActivities()
      .then((vesselActivities) => {
        const vesselActivitiesForVoyage = vesselActivities
          .filter((x) => filterActivities(x, Id));
        commit(SET_VESSEL_ACTIVITIES_TO_BE_SYNCED, vesselActivitiesForVoyage);

        // Check for updates for 'synced' activities
        const vesselActivityUpdates = vesselActivities
          .filter((x) => x.voyageReport && x.voyageReport.id === Id.toString());
        if (vesselActivityUpdates.length > 0) {
          const activities = vesselActivityUpdates.concat(vesselActivitiesForVoyage);
          commit(SET_VESSEL_ACTIVITIES_TO_BE_SYNCED, activities);
        }
      }).catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  loadVesselActivityBulkTransactionsToBeSynced({ commit }, id) {
    return Idb.getBulkTransactions()
      .then((transactions) => {
        const bulkTransactionsForActivity = transactions
          .filter((x) => x.vesselActivityId.toString() === id);

        commit(SET_BULK_TRANSACTIONS_TO_BE_SYNCED, bulkTransactionsForActivity);
      }).catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  loadAllBulkTransactionsToBeSynced({ commit }) {
    return Idb.getBulkTransactions().then((transactions) => {
      commit(SET_ALL_BULK_TRANSACTIONS_TO_BE_SYNCED, transactions);
    });
  },
  loadTankStatusesToBeSynced({ commit }) {
    return Idb.getTanksWithCurrentStatus().then((statuses) => {
      commit(SET_TANKS_WITH_CURRENT_STATUS_TO_BE_SYNCED, statuses);
    });
  },
  loadPassengersToBeSynced({ commit }) {
    return Idb.getPassengers().then((passengers) => {
      commit(SET_PASSENGERS_TO_BE_SYNCED, passengers);
    });
  },
  loadSafetyObservationsToBeSynced({ commit }) {
    return Idb.getSafetyObservations().then((safetyObservations) => {
      commit(SET_SAFETY_OBSERVATIONS_TO_BE_SYNCED, safetyObservations);
    });
  },
  loadAllCargoLinesToBeSynced({ commit }, voyageId) {
    return Idb.getCargoLines().then((cargoLines) => {
      commit(SET_ALL_CARGO_LINES_TO_BE_SYNCED, cargoLines);
    }).catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  loadCargoLinesToBeSyncedForVoyage({ commit }, voyageId) {
    return Idb.getCargoLines().then((cargoLines) => {
      const filteredCargoLines = cargoLines.filter((x) => {
        return (x.voyageReportId === voyageId);
      });
      commit(SET_CARGO_LINES_TO_BE_SYNCED, filteredCargoLines);
    }).catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  clearCargoLinesToBeSyncedForVoyage({ commit }) {
    commit(CLEAR_CARGO_LINES_TO_BE_SYNCED);
  },
  doDataSyncAndReloadVoyageReports({ commit, dispatch, rootState }, activeSiteId) {
    return Idb.getDataToBeSynced()
      .then((dataToSync) => {
        console.log('VRs to be synced', dataToSync.voyageReportsToBeSynced);
        console.log('VAs to be synced', dataToSync.vesselActivitiesToBeSynced);
        console.log('BTs to be synced', dataToSync.bulkTransactionsToBeSynced);
        console.log('TSs to be synced', dataToSync.tanksWithCurrentStatusToBeSynced);
        console.log('PAs to be synced', dataToSync.passengersToBeSynced);
        console.log('SOs to be synced', dataToSync.safetyObservationsToBeSynced);
        console.log('CLs to be synced', dataToSync.allCargoLinesToBeSynced);
        if (dataToSync.voyageReportsToBeSynced.length > 0
          || dataToSync.vesselActivitiesToBeSynced.length > 0
          || dataToSync.bulkTransactionsToBeSynced.length > 0
          || dataToSync.tanksWithCurrentStatusToBeSynced.length > 0
          || dataToSync.passengersToBeSynced.length > 0
          || dataToSync.safetyObservationsToBeSynced.length > 0
          || dataToSync.allCargoLinesToBeSynced.length > 0) {
          commit(SET_DATA_SYNCING_BOOL, true);
          DataSyncService.syncData(dataToSync, activeSiteId)
            .then((x) => x.data)
            .then((dataSyncResults) => {
              const {
                validVoyageReports,
                validVesselActivities,
                validBulkTransactions,
                validTankStatuses,
                validPassengers,
                validSafetyObservations,
                invalidVoyageReports,
                invalidVesselActivities,
                invalidBulkTransactions,
                invalidTankStatuses,
                invalidPassengers,
                invalidSafetyObservations,
              } = dataSyncResults;

              Idb.deleteMultipleVoyageReports(validVoyageReports);
              Idb.deleteMultipleVesselActivities(validVesselActivities);
              Idb.deleteMultipleBulkTransactions(validBulkTransactions);
              Idb.deleteMultipleTankStatuses(validTankStatuses);
              Idb.deleteMultiplePassengers(validPassengers);
              Idb.deleteMultipleSafetyObservations(validSafetyObservations);

              if (invalidVoyageReports.length > 0
                || invalidVesselActivities.length > 0
                || invalidBulkTransactions.length > 0
                || invalidTankStatuses.length > 0
                || invalidPassengers.length > 0
                || invalidSafetyObservations.length > 0) {
                console.error('Some Data Failed to Sync',
                  invalidVoyageReports,
                  invalidVesselActivities,
                  invalidBulkTransactions,
                  invalidTankStatuses,
                  invalidPassengers,
                  invalidSafetyObservations);
              } else {
                if (dataToSync.allCargoLinesToBeSynced.length > 0) {
                  dataToSync.allCargoLinesToBeSynced.forEach((cargoLine) => {
                    if (cargoLine.activityIdc !== undefined) {
                      var activity = validVesselActivities.find((va) => va.idc === cargoLine.activityIdc);
                      cargoLine.activityId = activity.id;
                      cargoLine.activityIdc = undefined;
                      if (cargoLine.offshoreLiftTime !== null) {
                        cargoLine.offshoreLiftTime = activity.endDateTimeLt;
                        cargoLine.activityEndDateTime = activity.endDateTimeLt;
                      }
                    }
                  });
                  dispatch('voyageReportsStore/updateOffshoreLiftTimeInFlow', { lines: dataToSync.allCargoLinesToBeSynced, voyageReportId: dataToSync.allCargoLinesToBeSynced[0].voyageReportId }, { root: true})
                      .then(() => {
                        Idb.deleteAllCargoLines().then(() => {
                          dispatch('clearCargoLinesToBeSyncedForVoyage');
                          dispatch('loadAllCargoLinesToBeSynced');
                        });
                      });
                  }
                console.log('%cSyncing Was Successful', 'background: #2BBD0A');
              }
            })
            .then((x) => dispatch('voyageReportsStore/loadVoyageReports', activeSiteId, { root: true }))
            .then((x) => dispatch('loadVoyageReportsToBeSynced'))
            .then((x) => dispatch('loadVesselActivitiesToBeSynced'))
            .then((x) => dispatch('loadAllVesselActivitiesToBeSynced'))
            .then((x) => dispatch('tanksStore/loadTankStatuses', activeSiteId, { root: true })
              .then(() => dispatch('loadTankStatusesToBeSynced')))
            .then(() => dispatch('loadPassengersToBeSynced'))
            .then(() => dispatch('loadSafetyObservationsToBeSynced'))
            .then((x) => {
              // refresh current voyage report details, activities and passengers
              const voyageReportId = rootState.voyageReportsStore.voyageReportDetailsData
                ? rootState.voyageReportsStore.voyageReportDetailsData.id
                : null;
              if (voyageReportId) {
                dispatch('voyageReportsStore/loadVoyageVesselActivities', voyageReportId, { root: true });
                dispatch('loadVesselActivitiesToBeSynced', voyageReportId);
                dispatch('passengersStore/loadPassengersForVoyage', voyageReportId, { root: true });
                dispatch('safetyObservationsStore/loadSafetyObservationsForVoyage', voyageReportId, { root: true });
              }
            })
            .catch((error) => ErrorHandlerHelpers.handleServiceError(error))
            .finally(() => commit(SET_DATA_SYNCING_BOOL, false));
        } else {
          console.log('No data to be synced');
        }
      });
  },
});

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
